import { RetrievalMethod, ACTIONS } from '../constants';
import { DefaultRequestAction, Facesheet, FilterParams } from '../types';

/**
 * Checks if facesheets array contains any HIE-tagged items
 */
const hasHieTaggedFacesheets = (facesheets: Facesheet[]): boolean => {
  return facesheets.some((facesheet) =>
    facesheet.templateTypes.includes('HIE'),
  );
};

export const getAvailableRequestActions = (
  params: FilterParams,
): DefaultRequestAction[] => {
  const {
    orgInfo,
    organizationFacesheets = [],
    profileAvailableMethods,
    profileFacesheets = [],
  } = params;

  if (!orgInfo) return [];

  const isEditFlow = !!profileAvailableMethods;
  const isAdvanced = orgInfo.enableAdvancedFacesheetsRequests === true;

  const availableActions: DefaultRequestAction[] = [];

  // For ordering
  availableActions.push(ACTIONS[RetrievalMethod.PROVIDER_FACILITY]);

  // Digital Health Data
  // FS2.0 (advanced): HIE is decoupled from facesheets, so org HIE enablement
  // alone makes it available.
  // FS1.0: Org has HIE enabled and either the org has HIE-tagged facesheets,
  // or the profile has FULL enabled and HIE-tagged facesheets.
  const hieAction = ACTIONS[RetrievalMethod.HIE];
  const isHieAvailable =
    orgInfo.enableHieRequests &&
    (isAdvanced ||
      hasHieTaggedFacesheets(organizationFacesheets) ||
      (profileAvailableMethods?.includes('FULL') &&
        hasHieTaggedFacesheets(profileFacesheets)));
  if (isHieAvailable) {
    availableActions.push(hieAction);
  }

  // Medications Data - Only in edit flow and org has MEDICATIONS enabled
  const medicationsAction = ACTIONS[RetrievalMethod.MEDICATIONS];
  if (isEditFlow && profileAvailableMethods?.includes('MEDICATIONS')) {
    availableActions.push(medicationsAction);
  }

  // Facesheets availability is org-level; empty profile templates are handled as a disabled option in the request selector.
  const facesheetsAction = ACTIONS[RetrievalMethod.FACESHEETS];
  if (orgInfo.enableFacesheetRequests) {
    availableActions.push(facesheetsAction);
  }

  // For ordering
  availableActions.push(ACTIONS[RetrievalMethod.RECORD_UPLOAD]);

  return availableActions;
};
